import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VeeValidateJaLocale from 'vee-validate/dist/locale/ja'

/*
// ここでメッセージ
const dictionary = {
  ja: {
    messages: {
      required: (field) => '' + field
    },
    attributes: {
      sponsorName: '',
      advert: '',
      phone: '',
      companyName: '',
      id: ''
    }
  }
}

// dddd
Validator.extend('advert', {
  messages: {
    ja: field => 'ID请输入选手6位ID号'
  },
  validate: value => {
    // if (getLength(value) > 8) {
    //   return value = limitMaxLength(value, 8)
    // }
  }
})
*/
// ここで上のやつもろもろ設定
// Validator.updateDictionary(dictionary)

// VeeValidate.Validator.addLocale(VeeValidateJaLocale)

VeeValidate.Validator.localize('ja', VeeValidateJaLocale)
Vue.use(VeeValidate, { locale: 'ja' })



// WEBPACK FOOTER //
// ./src/validate/validate.js